import React from "react"
import PropTypes from "prop-types"
import { myContext } from "../../provider"
import "../styles/translated-title.scss"

const TranslatedTitle = ({ en, fr }) => {
  return (
    <myContext.Consumer>
      {context => (
        <div className="translated-title">
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() =>
              context.currentLanguage === "fr" ? context.switchLanguage() : null
            }
            onClick={() =>
              context.currentLanguage === "fr" ? context.switchLanguage() : null
            }
            className={`title ${
              context.currentLanguage === "fr" ? "hidden" : ""
            }`}
          >
            {en}
          </div>
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() =>
              context.currentLanguage === "en" ? context.switchLanguage() : null
            }
            onClick={() =>
              context.currentLanguage === "en" ? context.switchLanguage() : null
            }
            className={`title ${
              context.currentLanguage === "en" ? "hidden" : ""
            }`}
          >
            {fr}
          </div>
        </div>
      )}
    </myContext.Consumer>
  )
}

TranslatedTitle.defaultProps = {
  fr: "",
  en: "",
}

TranslatedTitle.propTypes = {
  fr: PropTypes.string,
  en: PropTypes.string,
}

export default TranslatedTitle
